import { target_date } from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    bom_item: {
      name: 'Sub Job No.',
      width: '8rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.bom_item?.job_no,
    },
    code: {
      name: 'Drawing / Part No.',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item.bom_item?.drawing_no || row.item.bom_item.material?.code,
    },
    description: {
      name: 'Description',
      width: '12rem',
      filter: (val: string, row: any) => `${row.item.bom_item.description ? row.item.bom_item.description : row.item.bom_item.description}`,
    },
    material: {
      name: 'Material / Brand',
      width: '1fr',
      filter: (val: string, row: any) => `${row.item.material.brand ? row.item.material.brand : row.item.material.name}`,
    },
    amount: {
      name: 'จำนวน',
      width: '5rem',
      class: 'text-right',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    target_date,
  },
};
